import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import AdminColegiados from "../components/Colegiado/AdminColegiados";
import ColegiadoDetail from "../components/Colegiado/ColegiadoDetail";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Dashboard = () => {
  const [rol, setRol] = useState(null);
  const [codigo, setCodigo] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    // 🔴 Si el interceptor ya ha limpiado el token → fuera
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    try {
      const decoded = jwtDecode(token);

      setRol(decoded.rol || "COLEGIADO");

      // ⚠️ OJO: aquí estabas usando sub como codigo
      // Si ahora ya metes "codigo" en el JWT, usa ese
      setCodigo(decoded.codigo ?? decoded.sub);
    } catch (error) {
      console.error("Token inválido", error);
      localStorage.removeItem("token");
      navigate("/login", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  // 🔒 Si ya no hay token, NO renderices nada (evita axios en hijos)
  if (!localStorage.getItem("token")) {
    return null;
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return rol === "ADMIN"
    ? <AdminColegiados />
    : <ColegiadoDetail codigo={codigo} />;
};

export default Dashboard;
